var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharePresentationVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_4963)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_9501_4963)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#25282D",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5333 12.7676C12.6751 13.9001 10.003 18.7778 9.00392 23.8138C8.97197 23.9721 9.14333 24.0685 9.22756 23.9412C11.4001 20.6676 14.3626 19.1151 18.4723 19.036C18.6611 19.0325 18.815 19.2149 18.815 19.4387V22.4541C18.815 22.8121 19.181 22.9911 19.393 22.7398L24.8998 16.2133C25.0334 16.055 25.0334 15.8002 24.8998 15.6453L19.3959 9.11882C19.181 8.86409 18.8179 9.04653 18.8179 9.40453V12.3752C18.8179 12.5714 18.696 12.7366 18.5333 12.7676Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_9501_4963",
    x: -4,
    y: -4,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9501_4963"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9501_4963",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_4963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePresentationVideo);
export default __webpack_public_path__ + "static/media/share-presentation-video.7c8d9ee7fa44293ef97a49b178361576.svg";
export { ForwardRef as ReactComponent };